import { render, staticRenderFns } from "./BatchSetInfoModal.vue?vue&type=template&id=1f8df07f&scoped=true"
import script from "./BatchSetInfoModal.vue?vue&type=script&lang=js"
export * from "./BatchSetInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8df07f",
  null
  
)

export default component.exports